import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { ArrowLeft, Save } from 'lucide-react';
import { DynamicIcon } from '../components/icons/DynamicIcon';
import toast from 'react-hot-toast';

export default function DrinkForm() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [drink, setDrink] = useState({
    name: '',
    category: 'classicos',
    description: '',
    is_standard: true
  });

  const categorias = [
    'classicos', 'martinis', 'tropicais', 'frozen', 
    'quentes', 'shots', 'semalcool', 'caipirinhas', 'smoothies'
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { error } = await supabase
        .from('drinks')
        .insert([drink]);

      if (error) throw error;

      toast.success('Drink cadastrado com sucesso!');
      navigate('/drinks');
    } catch (error: any) {
      console.error('Erro:', error);
      toast.error('Erro ao cadastrar drink: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-2xl mx-auto p-6">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6"
        >
          <DynamicIcon name="arrowLeft" size={16} />
          Voltar
        </button>

        <div className="bg-white rounded-lg shadow p-6">
          <h1 className="text-2xl font-bold mb-6">Cadastrar Novo Drink</h1>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">Nome do Drink</label>
              <input
                type="text"
                required
                className="w-full border rounded-lg px-3 py-2"
                value={drink.name}
                onChange={(e) => setDrink({...drink, name: e.target.value})}
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Categoria</label>
              <select
                className="w-full border rounded-lg px-3 py-2"
                value={drink.category}
                onChange={(e) => setDrink({...drink, category: e.target.value})}
              >
                {categorias.map(cat => (
                  <option key={cat} value={cat}>
                    {cat.charAt(0).toUpperCase() + cat.slice(1)}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Tipo</label>
              <div className="flex gap-4">
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    checked={drink.is_standard}
                    onChange={() => setDrink({...drink, is_standard: true})}
                    className="text-blue-600"
                  />
                  <span>Standard</span>
                </label>
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    checked={!drink.is_standard}
                    onChange={() => setDrink({...drink, is_standard: false})}
                    className="text-blue-600"
                  />
                  <span>Premium</span>
                </label>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Descrição/Modo de Preparo</label>
              <textarea
                required
                rows={4}
                className="w-full border rounded-lg px-3 py-2"
                value={drink.description}
                onChange={(e) => setDrink({...drink, description: e.target.value})}
                placeholder="Descreva o drink e seu modo de preparo..."
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-purple-600 hover:bg-purple-700 text-white py-2 rounded-lg flex items-center justify-center gap-2 transition-colors"
            >
              {loading ? (
                <>
                  <DynamicIcon name="loader" size={16} className="animate-spin" />
                  Salvando...
                </>
              ) : (
                <>
                  <DynamicIcon name="save" size={16} />
                  Cadastrar Drink
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}